import React, { Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";
import globalUrls from "../globalUrls";

const LandingPage = lazy(() => import("../pages/LandingPage"));
const NotFoundPage = lazy(() => import("../pages/NotFoundPage"));
const AboutUsPage = lazy(() => import("../pages/AboutUsPage"));
const PricingPage = lazy(() => import("../pages/PricingPage"));

const AppRoutes: React.FC = () => {
  return (
    <Suspense fallback={<div />}> 
      <Routes>
        <Route
          path={globalUrls.LANDING_PAGE}
          element={<LandingPage />}
        />

        <Route
          path={globalUrls.ABOUT_US}
          element={<AboutUsPage />}
        />

        <Route
          path={globalUrls.PRICING}
          element={<PricingPage />}
        />

        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Suspense>
  );
};

export default AppRoutes;
